import { Link, useLocation } from 'react-router-dom';
import { motion, useScroll } from 'framer-motion';
import { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

export const Navbar = () => {
  const { scrollY } = useScroll();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const { theme } = useTheme();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'Work', path: '/work' },
    { name: 'Clients', path: '/clients' },
    { name: 'Contact', path: '/contact' },
  ];
    //Hidden Pages
    // { name: 'Products', path: '/products' },
    // { name: 'Recognition', path: '/recognition' },

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? theme === 'dark' 
            ? 'bg-black/90 backdrop-blur-md border-b border-themed shadow-lg' 
            : 'bg-white/90 backdrop-blur-md border-b border-themed shadow-lg'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="text-xl font-black lowercase text-primary">
          appdroid tech<span className="text-purple-500">.</span>
        </Link>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm font-medium transition-colors hover:text-purple-500 ${
                location.pathname === link.path ? 'text-purple-500' : 'text-primary'
              }`}
            >
              {link.name}
            </Link>
          ))}
          <Link
            to="/contact"
            data-testid="nav-contact-btn"
            className="border-2 border-purple-500 text-primary px-6 py-2 rounded-full font-bold text-sm transition-all hover:bg-purple-500 hover:text-white"
          >
            Let's Talk
          </Link>
        </div>

        {/* Mobile Menu Button */}
        <button
          data-testid="mobile-menu-btn"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          className="md:hidden text-primary z-50"
        >
          {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile Menu Overlay */}
      {isMenuOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-primary backdrop-blur-lg z-40 md:hidden"
        >
          <div className="flex flex-col items-center justify-center h-full gap-8">
            {navLinks.map((link, index) => (
              <motion.div
                key={link.path}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
              >
                <Link
                  to={link.path}
                  onClick={() => setIsMenuOpen(false)}
                  className={`text-3xl font-bold transition-colors hover:text-purple-500 ${
                    location.pathname === link.path ? 'text-purple-500' : 'text-primary'
                  }`}
                >
                  {link.name}
                </Link>
              </motion.div>
            ))}
          </div>
        </motion.div>
      )}
    </nav>
  );
};